export class TargetAppPredicate {
  isTargetAudience({
    apps
  }, {
    client: {
      appName
    }
  }) {
    return apps.size === 0 || apps.has(appName);
  }
}
export class MatchingTagPredicate {
  isTargetAudience({
    tags
  }, {
    client: {
      tags: clientTags
    }
  }) {
    return tags.size === 0 || Array.from(tags).some(tag => clientTags.includes(tag));
  }
}
export class ExcludeSelfPredicate {
  isTargetAudience({
    excludeSelf
  }, {
    subscriberClientId,
    message: {
      sender
    }
  }) {
    return !excludeSelf || subscriberClientId !== sender;
  }
}
export class SameWindowPredicate {
  isTargetAudience({
    sameWindow
  }, {
    client: {
      portalId
    },
    message: {
      senderPortalId
    }
  }) {
    return !sameWindow || !portalId || senderPortalId === portalId;
  }
}
export class CrossTabPredicate {
  isTargetAudience({
    allowCrossTab
  }, {
    message: {
      senderBrokerId
    },
    subscriberBrokerId
  }) {
    return allowCrossTab || senderBrokerId === subscriberBrokerId;
  }
}
export class CrossPortalPredicate {
  isTargetAudience({
    allowCrossPortal
  }, {
    message: {
      senderPortalId
    },
    client: {
      portalId
    }
  }) {
    const areClientAndSenderHubless = !senderPortalId && !portalId;
    return allowCrossPortal || areClientAndSenderHubless || senderPortalId === portalId;
  }
}